import React, { createContext, useContext } from 'react';

const SchemaFormContext = createContext({
  saveSchema: null,
});

export const useSchemaForm = () => {
  return useContext(SchemaFormContext);
};

export const SchemaFormProvider = ({ children, saveSchema }) => {
  return <SchemaFormContext.Provider value={{ saveSchema }}>{children}</SchemaFormContext.Provider>;
};
